import React, { useState, useMemo } from "react";
import {
  Box,
  Popover,
  Typography,
  Checkbox,
  List,
  Chip,
  TextField,
  InputAdornment,
  IconButton,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Close } from "@mui/icons-material";
import SendIcon from "../../../../assets/images/sendArrow.svg";
import styles from './DataLake.module.css'
// import {
//   sourceDropdown,
//   greenShade,
//   searchBox,
//   searchTextField,
//   sendIconWrapperStyle,
//   popoverPaperProps,
//   popoverTextField,
//   scrollBox,
//   checkboxSx,
//   optionMenuItem,
//   sourceChipSx,
//   suggestionChipSx,
//   suggestionRow,
//   suggestionContainer,
// } from "./Samarth.styles";

const OPTIONS = [
  "Cross Functional V3",
  "Cross Functional V4",
  "Cross Functional V5",
  "Cross Functional V6",
  "Cross Functional V7",
  "Cross Functional V8",
];

const SUGGESTIONS = [
  {
    label: "change in market share value vs py (Cross Functional V3)",
    source: "Cross Functional V3",
  },
  {
    label: "change in market share value (Cross Functional V5)",
    source: "Cross Functional V5",
  },
  { label: "change in market", source: "Cross Functional V3" },
  {
    label: "share value vs py (Cross Functional V3)",
    source: "Cross Functional V3",
  },
  {
    label: "market share growth % (Cross Functional V3)",
    source: "Cross Functional V3",
  },
  {
    label: "total revenue (Cross Functional V5)",
    source: "Cross Functional V5",
  },
];

const CHIP_COLORS = ["#EBF5FF", "#F6F7F0"];

function DataLake() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [selectedSuggestions, setSelectedSuggestions] = useState([]);

  const open = Boolean(anchorEl);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const toggleSource = (value) =>
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );

  const handleSelectSuggestion = (item) => {
    setSelectedSuggestions((prev) => {
      const exists = prev.find((s) => s.label === item.label);
      if (exists) return prev.filter((s) => s.label !== item.label);
      const chipColor = CHIP_COLORS[prev.length % CHIP_COLORS.length];
      return [...prev, { ...item, chipColor }];
    });
    setNewMessage("");
  };

  const removeSuggestion = (label) =>
    setSelectedSuggestions((prev) => prev.filter((s) => s.label !== label));

  const filteredOptions = useMemo(
    () =>
      OPTIONS.filter((o) => o.toLowerCase().includes(searchTerm.toLowerCase())),
    [searchTerm],
  );

  const filteredSuggestions = useMemo(() => {
    if (!newMessage.trim() || selected.length === 0) return [];
    const query = newMessage.toLowerCase();
    return SUGGESTIONS.filter(
      (s) =>
        selected.includes(s.source) && s.label.toLowerCase().includes(query),
    );
  }, [newMessage, selected]);

  return (
    <Box>
      <Box className={styles.sourceDropdown}>
        <Box display="flex" gap="16px">
          <Box onClick={handleOpen} className={styles.DropdownBox}>
            <Typography color="#5C738A">
              {selected.length
                ? `${selected.length} selected`
                : "Choose Source"}
            </Typography>
            <KeyboardArrowDownIcon style={{ color: "#667F93" }} />
          </Box>

          {/* Source chips */}
          <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
            {selected.map((item) => (
              <Chip
                key={item}
                label={item}
                className={styles.ChipBox}
                onDelete={() => toggleSource(item)}
                deleteIcon={<Close />}
                sx={styles.sourceChipSx}
              />
            ))}
          </Box>
        </Box>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          // PaperProps={styles.popoverPaperProps}
          slotProps={{
            paper: {
              sx: {
                mt: 1,
                width: 273,
                borderRadius: "12px",
                p: "16px 8px",
                background:
                  "linear-gradient(180deg, #C2E0FF -119.85%, #FFFFFF 100%)",
                boxShadow: "0px 4px 8px 0px #00000014",
                "& .MuiMenuItem-root": {
                  p: "12px",
                },
                "& .MuiCheckbox-root": {
                  display: "none",
                },
              },
            },
          }}
        >
          <Typography
            sx={{
              px: 2,
              py: 1,
              fontWeight: 600,
              color: "#4D5F6E",
              fontSize: "18px",
            }}
          >
            Choose Source
          </Typography>

          <TextField
            size="small"
            placeholder="Search"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={styles.popoverTextField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color: searchTerm ? "#1A2025" : "#9CA3AF",
                      fontSize: 20,
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchTerm("")}
                    sx={{ p: "4px" }}
                  >
                    <Close sx={{ fontSize: 18, color: "#0066CC" }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <List disablePadding>
            <Box className={styles.scrollBox}>
              {filteredOptions.length === 0 ? (
                <Typography
                  sx={{ px: 2, py: 1, fontSize: 14, textAlign: "center" }}
                >
                  No dashboards found
                </Typography>
              ) : (
                filteredOptions.map((option) => {
                  const isSelected = selected.includes(option);
                  return (
                    <MenuItem
                      key={option}
                      onClick={() => toggleSource(option)}
                      // sx={styles.optionMenuItem(isSelected)}
                      className={`${styles.optionMenuItem} ${
                        isSelected ? styles.selected : ""
                      }`}
                    >
                      <Checkbox
                        checked={isSelected}
                        className={styles.checkbox}
                      />
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#4D5F6E",
                        }}
                      >
                        {option}
                      </Typography>
                    </MenuItem>
                  );
                })
              )}
            </Box>
          </List>
        </Popover>

        <Box className={styles.greenShade}>
          <Box className={styles.searchBox}>
            {/* Message field */}
            <TextField
              fullWidth
              multiline
              minRows={1}
              maxRows={10}
              placeholder="Ask anything..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && newMessage.trim()) {
                  e.preventDefault();
                  const trimmedValue = newMessage.trim();
                  if (
                    selectedSuggestions.some(
                      (item) => item.label === trimmedValue,
                    )
                  ) {
                    return;
                  }

                  const newChip = {
                    label: trimmedValue,
                    chipColor:
                      CHIP_COLORS[
                        selectedSuggestions.length % CHIP_COLORS.length
                      ],
                  };

                  setSelectedSuggestions((prev) => [...prev, newChip]);
                  setNewMessage("");
                }
              }}
              variant="outlined"
              className={styles.searchTextField}
            />

            <Box display="flex" alignItems="center" width="100%">
              <Box display="flex" gap="16px" flexWrap="wrap" flex={1}>
                {selectedSuggestions.map((item) => (
                  <Chip
                    key={item.label}
                    label={item.label}
                    onDelete={() => removeSuggestion(item.label)}
                    deleteIcon={<Close />}
                    // sx={styles.suggestionChipSx(item.chipColor)}
                    className={styles.suggestionChip}
                    style={{ background: item.chipColor }}
                  />
                ))}
              </Box>

              <Box sx={{ display: "flex", justifyContent: "flex-end", ml: 2 }}>
                <Box
                  // sx={styles.sendIconWrapperStyle(!!newMessage.trim())}
                  className={`${styles.sendIconWrapper} ${
                    selectedSuggestions?.length > 0
                      ? styles.active
                      : styles.disabled
                  }`}
                  onClick={() => {}}
                >
                  <Box
                    component="img"
                    src={SendIcon}
                    sx={{ height: "24px", width: "24px" }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={styles.suggestionContainer}>
          {filteredSuggestions.map((item, index) => {
            const isSelected = selectedSuggestions.some(
              (s) => s.label === item.label,
            );
            return (
              <Box
                key={index}
                onClick={() => handleSelectSuggestion(item)}
                // sx={styles.suggestionRow(isSelected)}
                className={`${styles.suggestionRow} ${
                  isSelected ? styles.selected : ""
                }`}
              >
                <Typography>{item.label}</Typography>
                <Typography sx={{ color: "#667F93", fontSize: 14 }}>
                  {item.source}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default DataLake;